export default "__VITE_ASSET__Dmyu8SF2__"